import { css } from 'linaria';

export const contentList = css`
  display: flex;
  flex-direction: column;
`;

export const listTitle = css`
  padding: var(--space-200) 0 var(--space-100);
`;

export const additionalTextStyle = css`
  margin-top: var(--space-200);
  display: flex;
  flex-direction: column;
  gap: var(--space-50);
`;
